<aside class="main-sidebar">
    <section class="sidebar">
        <ul class="sidebar-menu nav-listing">
            <li class="d-none">
                <a href="" class="header-links dashboard" routerLink="/" routerLinkActive="active" ariaCurrentWhenActive="page" appTooltip="Dashboard">
                    <i></i>
                    <span>Dashboard</span>
                </a>
            </li>
            <li *hasPermission="['user.read', 'user.write']">
                <a href="" class="header-links users" routerLink="/users" routerLinkActive="active" ariaCurrentWhenActive="page" >
                    <i></i>
                    <span>Users</span>
                </a>
            </li>
            <li *hasPermission="['roles.read', 'roles.write']">
                <a href="" class="header-links user-role" routerLink="/roles" routerLinkActive="active" ariaCurrentWhenActive="page" >
                    <i></i>
                    <span>Roles & Permission</span>
                </a>
            </li>
            <li *hasPermission="['consumer.read', 'consumer.write']">
                <a href="" class="header-links consumer" routerLink="/consumers" routerLinkActive="active" ariaCurrentWhenActive="page" >
                    <i></i>
                    <span>API Consumers</span>
                </a>
            </li>
            <li *hasPermission="['station.read', 'station.write']">
                <a href="" class="header-links station" routerLink="/stations" routerLinkActive="active" ariaCurrentWhenActive="page" >
                    <i></i>
                    <span>Stations</span>
                </a>
            </li>
            <li *hasPermission="['trainoperatingcompany.read', 'trainoperatingcompany.write']">
                <a href="" class="header-links toc" routerLink="/toc" routerLinkActive="active" ariaCurrentWhenActive="page" >
                    <i></i>
                    <span>Train Operating Company</span>
                </a>
            </li>
            <li *hasPermission="['video.read', 'video.write']">
                <a href="" class="header-links video" routerLink="/videos" routerLinkActive="active" ariaCurrentWhenActive="page" >
                    <i></i>
                    <span>Video Management</span>
                </a>
            </li>
            <li *hasPermission="['purgecache.write']">
                <a href="javascript:;" class="header-links purge" ariaCurrentWhenActive="page" (click)="openPurgeCacheDialog()">
                    <i></i>
                    <span>Purge Management</span>
                </a>
            </li>
            <li class="d-none">
                <a href="" class="header-links products" routerLink="/claims" routerLinkActive="active" ariaCurrentWhenActive="page" appTooltip="Claims">
                    <i></i>
                    <span>Claims</span>
                </a>
            </li>
            <li class="d-none">
                <a href="" class="header-links configuration" routerLink="/configuration" routerLinkActive="active" ariaCurrentWhenActive="page" appTooltip="Configuration">
                    <i></i>
                    <span>Configuration</span>
                </a>
            </li>
        </ul>
    </section>
</aside>